// Sticky "add to cart" at the bottom
document.addEventListener("DOMContentLoaded", function () {
  const atc = document.getElementById("StickyATC");
  let lastScrollY = window.scrollY;
  let ticking = false;
  function updateAtc() {
    const currentScrollY = window.scrollY;
    if (Math.abs(currentScrollY - lastScrollY) > 10) {
      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        atc.classList.add("translate-y-full");
      } else {
        atc.classList.remove("translate-y-full");
      }
      lastScrollY = currentScrollY;
    }
    ticking = false;
  }
  window.addEventListener(
    "scroll",
    () => {
      if (!ticking) {
        requestAnimationFrame(updateAtc);
        ticking = true;
      }
    },
    { passive: true }
  );
});

// Pop up for te notice when click "add to cart"
// document.addEventListener("DOMContentLoaded", function () {
//   const banner = document.getElementById("product-popup");
//   const button = document.getElementById("product-popup-button");
//   const hideButton = document.getElementById("product-popup-hide");
//   button.addEventListener("click", function () {
//     banner.classList.remove("hidden");
//     document.body.style.overflow = 'hidden';
//   });
//   hideButton.addEventListener("click", function () {
//     banner.classList.add("hidden");
//     document.body.style.overflow = '';
//   });
// });


// For PDP buttons
document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".product-popup-button");
  buttons.forEach(function(button){
    button.addEventListener("click", function(){
      // const banner = button.nextElementSibling;
      const banner = document.querySelector(".product-popup");
      const hideButton = banner.querySelector(".product-popup-hide");
      banner.classList.remove("hidden");
      document.body.style.overflow = 'hidden';
      hideButton.addEventListener("click", function(){
        banner.classList.add("hidden");
        document.body.style.overflow = '';
      });
    });
  });
});
